export default "/_next/static/images/3-fe6eefcdc2f8fefeedd91dcc8c2af10b.png";